import React from 'react';
import { MapPin, Phone, Mail, Building2, ArrowUpRight } from 'lucide-react';
import { companyInfo, contactContent } from '../data/mock';

const ContactSection = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="section-header">
          <span className="section-subtitle">{contactContent.subtitle}</span>
          <h2 className="section-title">{contactContent.title}</h2>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-icon">
                <Building2 size={24} />
              </div>
              <div className="contact-details">
                <h3>{companyInfo.fullName}</h3>
                <p>IČO: {companyInfo.ico}</p>
                <p className="parent-info">{companyInfo.parentCompany}</p>
              </div>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <MapPin size={24} />
              </div>
              <div className="contact-details">
                <h3>Adresa</h3>
                <p>{companyInfo.address}</p>
              </div>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <Phone size={24} />
              </div>
              <div className="contact-details">
                <h3>Telefon</h3>
                <a href={`tel:${companyInfo.phone}`} className="contact-link">
                  {companyInfo.phone}
                  <ArrowUpRight size={16} />
                </a>
              </div>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <Mail size={24} />
              </div>
              <div className="contact-details">
                <h3>Email</h3>
                <a href={`mailto:${companyInfo.email}`} className="contact-link">
                  {companyInfo.email}
                  <ArrowUpRight size={16} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
